<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <inActive>
        </inActive> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import inActive from './todo-inactive'
export default {
    components: {
        inActive
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-job-information/base-inactive.vue